import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetTaskCategories_taskCategories as GetTaskCategoriesCategoryGenerated,
  GetTaskCategories as GetTaskCategoriesGenerated,
  GetTaskCategoriesVariables as GetTaskCategoriesVariablesGenerated,
} from "core/queries/__generated__/GetTaskCategories";

export interface GetTaskCategoriesVariables
  extends GetTaskCategoriesVariablesGenerated {}
export interface GetTaskCategoriesResponse extends GetTaskCategoriesGenerated {}
export interface GetTaskCategoriesCategory
  extends GetTaskCategoriesCategoryGenerated {}

export const getTaskCategories = gql`
  query GetTaskCategories($filters: TaskCategoryFilterInput!) {
    taskCategories(filters: $filters) {
      id
      name
    }
  }
`;

export interface UseGetTaskCategoriesQueryOptions {
  skip: boolean;
  variables: GetTaskCategoriesVariables;
}

export const useGetTaskCategoriesQuery = ({
  skip = false,
  variables,
}: UseGetTaskCategoriesQueryOptions) =>
  useQuery<GetTaskCategoriesResponse, GetTaskCategoriesVariables>(
    getTaskCategories,
    {
      skip,
      variables,
    },
  );
